module.exports = __webpack_public_path__ + "static/ocorie-abt-1-7ce1ee863ff3ca63ed9337f42a5d734f.png";